import Vue from "vue"
import Vuex from "vuex";

Vue.use(Vuex)

import GeneralStore from "./modules/GeneralStore"
import CreateAudienceStore from "./modules/CreateAudience"
import ActivateAudienceStore from "./modules/ActivateAudience"
import CreateCohortStore from "./modules/CreateCohort";

export default new Vuex.Store({
    modules: {
        GeneralStore,
        CreateAudienceStore,
        ActivateAudienceStore,
        CreateCohortStore
    }
})